import { RouteRecordRaw } from "vue-router";
import { t } from "@/core/i18n";

export const route: RouteRecordRaw = {
  path: "/referral-codes",
  name: "referral-codes",
  redirect: { name: "ReferralCodesList" },
  children: [
    {
      path: "list",
      name: "ReferralCodesList",
      component: () => import("./screens/ReferralCodesList.vue"),
      meta: {
        breadcrumb: [
          { title: t("referral-codes"), routeName: "referral-codes" },
          { title: t("manage-referral-codes"), routeName: "ReferralCodesList" },
        ],
      },
    },
    {
      path: "create",
      name: "CreateReferralCode",
      component: () => import("./screens/ReferralCodeForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("referral-codes"), routeName: "referral-codes" },
          { title: t("manage-referral-codes"), routeName: "ReferralCodesList" },
          { title: t("create-referral-code"), routeName: "CreateReferralCode" },
        ],
      },
    },
    {
      path: ":id",
      name: "ReferralCodeDetail",
      component: () => import("./screens/ReferralCodeDetail.vue"),
      meta: {
        breadcrumb: [
          { title: t("referral-codes"), routeName: "referral-codes" },
          { title: t("manage-referral-codes"), routeName: "ReferralCodesList" },
          { title: t("referral-code-report"), routeName: "ReferralCodeDetail" },
        ],
      },
    },
    {
      path: ":id/edit",
      name: "UpdateReferralCode",
      component: () => import("./screens/ReferralCodeForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("referral-codes"), routeName: "referral-codes" },
          { title: t("manage-referral-codes"), routeName: "ReferralCodesList" },
          { title: t("update-referral-code"), routeName: "UpdateReferralCode" },
        ],
      },
    },
  ],
};
